import './CalendarDate.css';
export default {
    "calendarCell": "CalendarDate_calendarCell__18bd0",
    "selected": "CalendarDate_selected__18bd0",
    "enabled": "CalendarDate_enabled__18bd0",
    "today": "CalendarDate_today__18bd0",
    "icon": "CalendarDate_icon__18bd0",
    "selectedIcon": "CalendarDate_selectedIcon__18bd0"
};
